var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWith(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202.999,
    height: 67.3,
    viewBox: "0 0 202.999 67.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.257,
    y1: 0.5,
    x2: 13.595,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#eda021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#e79f2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#d79b44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#bc9667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#948f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#5a86b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#2b83c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#36579e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393086"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -3.572,
    y1: 0.5,
    x2: 28.785,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.21,
    y1: 0.5,
    x2: 25.983,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.142,
    y1: 0.5,
    x2: 4.858,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.977,
    y1: 0.5,
    x2: 5.695,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2.844,
    y1: 0.5,
    x2: 6.18,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -4.708,
    y1: 0.5,
    x2: 6.021,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -5.982,
    y1: 0.5,
    x2: 4.978,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -6.277,
    y1: 0.5,
    x2: 3.414,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -6.394,
    y1: 0.5,
    x2: 2.05,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -8.524,
    y1: 0.5,
    x2: 1.093,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-5.347 -4.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6453",
    "data-name": "Group 6453",
    transform: "translate(5.347 4.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6451",
    "data-name": "Group 6451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6450",
    "data-name": "Group 6450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14943",
    "data-name": "Path 14943",
    d: "M52.573,55.735c-.954,2.731-3.561,9.291-5.7,9.115-1.333-.111-1.339-2.751-1.339-3.659V60.93A45.091,45.091,0,0,1,47.457,50a1.318,1.318,0,0,0,.033-.353c0-1.111-1.594-2.235-2.718-2.594a2.122,2.122,0,0,0-.582-.091,1.741,1.741,0,0,0-1.666,1.235l-.464,1.647a44.331,44.331,0,0,0-1.79,11.336l.052,1.437c.144,2.614,1.313,6.665,3.927,7.089a3.867,3.867,0,0,0,.706.046h.065c4.946,0,7.4-8.252,8.043-11.01.418-1.81.529-2.293.595-2.836C53.756,55.029,52.861,54.905,52.573,55.735Z",
    transform: "translate(-17.451 -19.204)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14944",
    "data-name": "Path 14944",
    d: "M48.11,37.462a3.552,3.552,0,0,1,.176-1.124c.627-1.973,1.928-2.738,3.189-2.738a2.749,2.749,0,0,1,2.783,2.692,3.819,3.819,0,0,1-.764,2.2A3.433,3.433,0,0,1,50.711,40.2,2.64,2.64,0,0,1,48.11,37.462Z",
    transform: "translate(-20.169 -14.573)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14945",
    "data-name": "Path 14945",
    d: "M38.37,8.91a4.052,4.052,0,0,1,.2-1.287C39.3,5.356,40.788,4.48,42.232,4.48a3.156,3.156,0,0,1,3.2,3.091,4.459,4.459,0,0,1-.876,2.529,3.953,3.953,0,0,1-3.2,1.96A3.033,3.033,0,0,1,38.37,8.91Z",
    transform: "translate(-16.793 -4.48)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14946",
    "data-name": "Path 14946",
    d: "M47.121,18.13a2.17,2.17,0,0,0-1.764-1.15,2.234,2.234,0,0,0-.294.026c-.928.176-1.333,1.039-1.692,1.8a5.973,5.973,0,0,1-.536.974,3.545,3.545,0,0,1-3.038,1.1c-.346,0-.686-.02-1.019-.046-2.476-.209-4.972-.608-7.39-.993-2.078-.333-4.221-.68-6.351-.9a43.072,43.072,0,0,0-4.417-.242c-1.026,0-2.032.046-2.986.137A18.421,18.421,0,0,0,10.2,20.92a9.66,9.66,0,0,0-4.5,5.044A6.211,6.211,0,0,0,8,33.21a3.34,3.34,0,0,0,1.64.49,2.039,2.039,0,0,0,1.072-.287c1.143-.7,1.17-2.306.706-3.509-.131-.333-.287-.66-.438-.987a5.47,5.47,0,0,1-.68-2.078,3.328,3.328,0,0,1,1.339-2.6,7.963,7.963,0,0,1,2.9-1.333,20.98,20.98,0,0,1,5.567-.745,21.6,21.6,0,0,1,3.443.281c-.052.157-.1.307-.157.464h-.013a102.9,102.9,0,0,0-4.685,15.825c-1.353,6.462-1.673,11.343-1.026,15.825a6.04,6.04,0,0,0,1.052,2.973c1.045,1.313,2.836,1.647,4.456,1.8a2.787,2.787,0,0,0,.333.013,1.286,1.286,0,0,0,1.294-.64,1.49,1.49,0,0,0-.176-1.339c-1.96-3.9-1.633-8.664-1.137-12.382a110.538,110.538,0,0,1,5.312-20.9l.3-.843h.013c.026-.078.052-.163.072-.248A61.255,61.255,0,0,0,40.43,24.383,9.058,9.058,0,0,0,45.6,23.155C47.121,22.129,48.133,19.9,47.121,18.13Z",
    transform: "translate(-5.347 -8.813)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6452",
    "data-name": "Group 6452",
    transform: "translate(35.109 22.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14947",
    "data-name": "Path 14947",
    d: "M59.08,68.964V49.342h5.835V50.6a7.348,7.348,0,0,1,4.757-1.633,7.264,7.264,0,0,1,3.241.706,6.563,6.563,0,0,1,2.411,2.006,7.928,7.928,0,0,1,2.738-2.006,8.407,8.407,0,0,1,3.456-.706,7.228,7.228,0,0,1,3.816,1,7.111,7.111,0,0,1,2.614,2.783A8.546,8.546,0,0,1,88.9,56.87V68.964H83.073V57.686a3.772,3.772,0,0,0-.849-2.594,2.854,2.854,0,0,0-2.254-.967A4.1,4.1,0,0,0,78.2,54.5a3.71,3.71,0,0,0-1.366,1.111c.026.2.039.405.052.614s.02.425.02.647V68.964H71.076V57.686a3.772,3.772,0,0,0-.849-2.594,2.854,2.854,0,0,0-2.254-.967,4.161,4.161,0,0,0-1.745.353,3.421,3.421,0,0,0-1.313,1.059V68.964Z",
    transform: "translate(-59.08 -42.07)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14948",
    "data-name": "Path 14948",
    d: "M110.46,65.8V39.83h12.5a10.518,10.518,0,0,1,4.554.928,7.484,7.484,0,0,1,3.078,2.581,6.61,6.61,0,0,1,1.117,3.8,6.036,6.036,0,0,1-.771,2.986,7.269,7.269,0,0,1-2.11,2.359,7.508,7.508,0,0,1,2.685,2.411,5.76,5.76,0,0,1,.993,3.267,7.162,7.162,0,0,1-1.117,3.986,7.5,7.5,0,0,1-3.136,2.692,10.791,10.791,0,0,1-4.685.967H110.46Zm6.194-15.616h5.907a3.135,3.135,0,0,0,2.163-.706,2.6,2.6,0,0,0,0-3.731,3.193,3.193,0,0,0-2.163-.686h-5.907V50.18Zm0,10.389H123.1a3.334,3.334,0,0,0,2.287-.745,2.793,2.793,0,0,0,0-4.012,3.334,3.334,0,0,0-2.287-.745h-6.449v5.5Z",
    transform: "translate(-76.888 -38.902)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14949",
    "data-name": "Path 14949",
    d: "M155.706,69.534a7.687,7.687,0,0,1-3.947-1,7.068,7.068,0,0,1-2.685-2.8,8.51,8.51,0,0,1-.974-4.1V49.54h5.835V60.818a3.566,3.566,0,0,0,.954,2.581,3.332,3.332,0,0,0,2.5.98,4.639,4.639,0,0,0,1.98-.405,3.872,3.872,0,0,0,1.437-1.15V49.54h5.835V69.161h-5.835V67.829A7.962,7.962,0,0,1,155.706,69.534Z",
    transform: "translate(-89.935 -42.268)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14950",
    "data-name": "Path 14950",
    d: "M190.768,69.34a10.032,10.032,0,0,1-5.136-1.333,9.856,9.856,0,0,1-3.62-3.652,10.75,10.75,0,0,1,0-10.369,10,10,0,0,1,3.62-3.652,9.886,9.886,0,0,1,5.136-1.353,10.776,10.776,0,0,1,4.463.947,10,10,0,0,1,3.6,2.692l-3.568,3.822a7.016,7.016,0,0,0-2.052-1.725,4.955,4.955,0,0,0-2.306-.536,4.087,4.087,0,0,0-2.267.647,4.506,4.506,0,0,0-1.588,1.777,5.58,5.58,0,0,0-.575,2.581,5.362,5.362,0,0,0,.595,2.542,4.6,4.6,0,0,0,1.64,1.784,4.345,4.345,0,0,0,2.339.647,4.725,4.725,0,0,0,2.2-.516,6.692,6.692,0,0,0,1.947-1.594l3.456,3.711a9.946,9.946,0,0,1-3.528,2.653A10.627,10.627,0,0,1,190.768,69.34Z",
    transform: "translate(-101.227 -42.074)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14951",
    "data-name": "Path 14951",
    d: "M211.72,65.3V39.338l5.835-.928V53.693l7.6-8.011h6.521l-8.468,8.867L232.25,65.3h-7.383l-7.311-8.788V65.3Z",
    transform: "translate(-111.986 -38.41)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14952",
    "data-name": "Path 14952",
    d: "M245.07,65.8V39.83H255.3a13.487,13.487,0,0,1,5.221,1,13.246,13.246,0,0,1,4.234,2.783,13.085,13.085,0,0,1,2.849,4.156,12.711,12.711,0,0,1,1.026,5.116,12.368,12.368,0,0,1-1.026,5.044,12.8,12.8,0,0,1-2.849,4.1,13.412,13.412,0,0,1-9.455,3.764H245.07Zm6.194-5.639h3.888a6.818,6.818,0,0,0,2.757-.555,7.144,7.144,0,0,0,3.77-3.875,7.405,7.405,0,0,0,.542-2.836,7.834,7.834,0,0,0-.542-2.914,7.168,7.168,0,0,0-3.77-3.933,6.6,6.6,0,0,0-2.757-.575h-3.888Z",
    transform: "translate(-123.545 -38.902)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14953",
    "data-name": "Path 14953",
    d: "M294.713,69.34a10.321,10.321,0,0,1-5.26-1.353,10.152,10.152,0,0,1-3.711-3.652,9.88,9.88,0,0,1-1.372-5.155A9.983,9.983,0,0,1,285.742,54a10.1,10.1,0,0,1,3.711-3.672,10.9,10.9,0,0,1,10.52,0A10.1,10.1,0,0,1,303.684,54a9.984,9.984,0,0,1,1.372,5.175,9.88,9.88,0,0,1-1.372,5.155,10.152,10.152,0,0,1-3.711,3.652A10.338,10.338,0,0,1,294.713,69.34Zm0-5.195a4.334,4.334,0,0,0,2.378-.666,4.815,4.815,0,0,0,1.653-1.8,5.485,5.485,0,0,0,0-5.044,4.761,4.761,0,0,0-1.673-1.8,4.507,4.507,0,0,0-4.717,0,4.761,4.761,0,0,0-1.673,1.8,5.206,5.206,0,0,0-.614,2.542,5.126,5.126,0,0,0,.614,2.5,4.761,4.761,0,0,0,1.673,1.8A4.331,4.331,0,0,0,294.713,64.145Z",
    transform: "translate(-137.166 -42.074)",
    fill: "url(#linear-gradient-11)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6455",
    "data-name": "Group 6455",
    transform: "translate(41.318 59.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6454",
    "data-name": "Group 6454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14954",
    "data-name": "Path 14954",
    d: "M60.4,98.749V90h1.274v8.749Z",
    transform: "translate(-60.4 -89.634)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14955",
    "data-name": "Path 14955",
    d: "M64.78,99.948V93.584H66v.653a2.416,2.416,0,0,1,1.856-.778,2.449,2.449,0,0,1,1.255.314,2.236,2.236,0,0,1,.849.876,2.621,2.621,0,0,1,.307,1.3v4H69.047V96.165a1.664,1.664,0,0,0-.405-1.183,1.487,1.487,0,0,0-1.137-.431,1.774,1.774,0,0,0-.876.216,1.744,1.744,0,0,0-.64.614v4.574H64.78Z",
    transform: "translate(-61.918 -90.833)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14956",
    "data-name": "Path 14956",
    d: "M78.007,98.722a2.934,2.934,0,0,1-1.575-.438A3.169,3.169,0,0,1,75.3,97.1a3.386,3.386,0,0,1-.412-1.666A3.245,3.245,0,0,1,76.445,92.6a2.963,2.963,0,0,1,1.588-.438,2.911,2.911,0,0,1,.98.163,3.09,3.09,0,0,1,.876.477V89.875L81.1,89.64v8.984H79.9V98.01A2.724,2.724,0,0,1,78.007,98.722Zm.157-1.091a2.279,2.279,0,0,0,.974-.2,2.009,2.009,0,0,0,.745-.575V93.992a2.184,2.184,0,0,0-.745-.555,2.283,2.283,0,0,0-.974-.209,2.043,2.043,0,0,0-1.059.287,2.065,2.065,0,0,0-.751.784,2.2,2.2,0,0,0-.281,1.117,2.225,2.225,0,0,0,.281,1.124,2.083,2.083,0,0,0,.751.791A1.884,1.884,0,0,0,78.164,97.631Z",
    transform: "translate(-65.422 -89.509)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14957",
    "data-name": "Path 14957",
    d: "M87.128,91.269a.7.7,0,0,1-.523-.229.76.76,0,0,1-.216-.542.739.739,0,0,1,.216-.542.715.715,0,0,1,.523-.216.745.745,0,0,1,.536.216.714.714,0,0,1,.216.542.76.76,0,0,1-.216.542A.721.721,0,0,1,87.128,91.269Zm-.608,7.39V92.295h1.215v6.364Z",
    transform: "translate(-69.408 -89.544)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14958",
    "data-name": "Path 14958",
    d: "M92.424,100.059a2.683,2.683,0,0,1-1.176-.242,2,2,0,0,1-.8-.68,1.759,1.759,0,0,1-.294-1.013,1.7,1.7,0,0,1,.666-1.418,2.913,2.913,0,0,1,1.83-.516,3.923,3.923,0,0,1,1.686.359v-.673a1.327,1.327,0,0,0-.379-1.026,1.662,1.662,0,0,0-1.124-.34,3.363,3.363,0,0,0-.889.131,6.289,6.289,0,0,0-1.032.405l-.451-.934a7.556,7.556,0,0,1,1.313-.5A4.872,4.872,0,0,1,93,93.46a2.7,2.7,0,0,1,1.862.588,2.128,2.128,0,0,1,.66,1.673v4.221H94.332v-.549a2.938,2.938,0,0,1-.889.5A3.145,3.145,0,0,1,92.424,100.059Zm-1.1-1.96a.9.9,0,0,0,.379.745,1.633,1.633,0,0,0,1,.281,2.625,2.625,0,0,0,.9-.144,2.11,2.11,0,0,0,.745-.457V97.452a2.643,2.643,0,0,0-.732-.307,3.474,3.474,0,0,0-.856-.091,1.733,1.733,0,0,0-1.052.281A.885.885,0,0,0,91.32,98.1Z",
    transform: "translate(-70.711 -90.833)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14959",
    "data-name": "Path 14959",
    d: "M99.79,92.354l.751-2.914h1.287l-1.117,2.914Z",
    transform: "translate(-74.053 -89.44)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14960",
    "data-name": "Path 14960",
    d: "M105.875,100.079a4.464,4.464,0,0,1-1.5-.242,3.611,3.611,0,0,1-1.209-.693l.666-.823a3.858,3.858,0,0,0,.98.595,2.691,2.691,0,0,0,1.026.209,1.934,1.934,0,0,0,1.065-.261.791.791,0,0,0,.412-.686.661.661,0,0,0-.242-.549,1.589,1.589,0,0,0-.751-.274l-1.117-.163a2.451,2.451,0,0,1-1.385-.588,1.6,1.6,0,0,1-.464-1.2,1.742,1.742,0,0,1,.3-1.006,2,2,0,0,1,.849-.673,3.1,3.1,0,0,1,1.274-.242,4.051,4.051,0,0,1,1.287.2,4.092,4.092,0,0,1,1.189.627l-.621.823a3.847,3.847,0,0,0-.987-.51,2.919,2.919,0,0,0-.967-.163,1.483,1.483,0,0,0-.9.242.742.742,0,0,0-.34.634.662.662,0,0,0,.235.542,1.6,1.6,0,0,0,.784.268l1.117.163a2.583,2.583,0,0,1,1.4.582,1.56,1.56,0,0,1,.47,1.2,1.674,1.674,0,0,1-.34,1.032,2.376,2.376,0,0,1-.921.719A3.6,3.6,0,0,1,105.875,100.079Z",
    transform: "translate(-75.224 -90.84)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14961",
    "data-name": "Path 14961",
    d: "M116.589,98.746l.738-2.614H116.04V95.2h1.529l.47-1.673h-1.4V92.6h1.64l.725-2.614h1.1l-.725,2.614h2.169l.725-2.614h1.091l-.725,2.614h1.287v.928H122.4l-.47,1.673h1.4v.928h-1.653l-.725,2.614h-1.091l.725-2.614h-2.169l-.725,2.614Zm2.084-3.541h2.176l.464-1.673h-2.169Z",
    transform: "translate(-79.685 -89.631)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14962",
    "data-name": "Path 14962",
    d: "M130.679,98.749V91.287l-1.529.66v-1.1L131.117,90h.764v8.749Z",
    transform: "translate(-84.229 -89.634)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14963",
    "data-name": "Path 14963",
    d: "M142.189,98.811a4.893,4.893,0,0,1-1.967-.412,5.108,5.108,0,0,1-1.673-1.163l.778-.928a5.213,5.213,0,0,0,1.411,1.039,3.583,3.583,0,0,0,1.509.34,2.9,2.9,0,0,0,1.085-.183,1.575,1.575,0,0,0,.719-.516,1.224,1.224,0,0,0,.255-.764,1.074,1.074,0,0,0-.4-.9,3.093,3.093,0,0,0-1.32-.477l-1.418-.235a3.285,3.285,0,0,1-1.745-.778,2,2,0,0,1-.575-1.5,2.306,2.306,0,0,1,.385-1.32,2.557,2.557,0,0,1,1.1-.882,4.023,4.023,0,0,1,1.647-.314,5.611,5.611,0,0,1,1.816.307,5.205,5.205,0,0,1,1.607.882l-.706,1a4.48,4.48,0,0,0-2.777-1.078,2.621,2.621,0,0,0-.974.163,1.446,1.446,0,0,0-.64.457,1.055,1.055,0,0,0-.229.68.974.974,0,0,0,.353.817,2.586,2.586,0,0,0,1.163.405l1.372.235a3.818,3.818,0,0,1,1.98.81,2.106,2.106,0,0,1,.634,1.614,2.4,2.4,0,0,1-.425,1.4,2.737,2.737,0,0,1-1.189.941A4.131,4.131,0,0,1,142.189,98.811Z",
    transform: "translate(-87.487 -89.572)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14964",
    "data-name": "Path 14964",
    d: "M152.976,99.1a1.963,1.963,0,0,1-1.372-.431,1.617,1.617,0,0,1-.47-1.255V93.679H149.82V92.628h1.313V91l1.2-.3v1.928h1.823v1.052h-1.823v3.45a.925.925,0,0,0,.216.693.982.982,0,0,0,.7.209,2.436,2.436,0,0,0,.457-.039c.131-.026.274-.065.431-.111v1.052a2.632,2.632,0,0,1-.562.131A4.96,4.96,0,0,1,152.976,99.1Z",
    transform: "translate(-91.393 -89.877)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14965",
    "data-name": "Path 14965",
    d: "M160.211,100.138a2.474,2.474,0,0,1-1.261-.314,2.167,2.167,0,0,1-.849-.882,2.735,2.735,0,0,1-.3-1.307V93.65H159v3.777a1.652,1.652,0,0,0,.418,1.189,1.476,1.476,0,0,0,1.124.438,1.807,1.807,0,0,0,.889-.216,1.7,1.7,0,0,0,.634-.621V93.657h1.215v6.364h-1.215v-.647A2.483,2.483,0,0,1,160.211,100.138Z",
    transform: "translate(-94.159 -90.899)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14966",
    "data-name": "Path 14966",
    d: "M171.057,98.722a2.935,2.935,0,0,1-1.575-.438,3.169,3.169,0,0,1-1.13-1.183,3.386,3.386,0,0,1-.412-1.666A3.245,3.245,0,0,1,169.5,92.6a2.963,2.963,0,0,1,1.588-.438,2.911,2.911,0,0,1,.98.163,3.09,3.09,0,0,1,.876.477V89.875l1.215-.235v8.984h-1.2V98.01A2.735,2.735,0,0,1,171.057,98.722Zm.157-1.091a2.279,2.279,0,0,0,.974-.2,2.009,2.009,0,0,0,.745-.575V93.992a2.184,2.184,0,0,0-.745-.555,2.282,2.282,0,0,0-.974-.209,2.043,2.043,0,0,0-1.059.287,2.065,2.065,0,0,0-.751.784,2.2,2.2,0,0,0-.281,1.117,2.225,2.225,0,0,0,.281,1.124,2.083,2.083,0,0,0,.751.791A1.855,1.855,0,0,0,171.214,97.631Z",
    transform: "translate(-97.674 -89.509)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14967",
    "data-name": "Path 14967",
    d: "M182.441,100.066a3.136,3.136,0,0,1-1.647-.438,3.224,3.224,0,0,1-1.163-1.189,3.288,3.288,0,0,1-.431-1.673,3.3,3.3,0,0,1,1.529-2.842,2.9,2.9,0,0,1,1.568-.444,2.709,2.709,0,0,1,1.529.444,3.155,3.155,0,0,1,1.059,1.2,3.644,3.644,0,0,1,.392,1.705v.353h-4.868a2.287,2.287,0,0,0,.385.934,2.112,2.112,0,0,0,.725.653,2.016,2.016,0,0,0,.967.235,2.608,2.608,0,0,0,.869-.144,1.866,1.866,0,0,0,.7-.418l.778.791a4.136,4.136,0,0,1-1.124.634A4.062,4.062,0,0,1,182.441,100.066Zm-2.012-3.829h3.652a2.087,2.087,0,0,0-.333-.882,1.934,1.934,0,0,0-.64-.6,1.655,1.655,0,0,0-.83-.216,1.728,1.728,0,0,0-.849.216,1.817,1.817,0,0,0-.647.595A2.191,2.191,0,0,0,180.428,96.237Z",
    transform: "translate(-101.576 -90.84)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14968",
    "data-name": "Path 14968",
    d: "M190.28,99.948V93.584H191.5v.653a2.416,2.416,0,0,1,1.856-.778,2.449,2.449,0,0,1,1.255.314,2.235,2.235,0,0,1,.849.876,2.621,2.621,0,0,1,.307,1.3v4h-1.215V96.165a1.664,1.664,0,0,0-.405-1.183A1.487,1.487,0,0,0,193,94.551a1.774,1.774,0,0,0-.876.216,1.744,1.744,0,0,0-.64.614v4.574H190.28Z",
    transform: "translate(-105.417 -90.833)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14969",
    "data-name": "Path 14969",
    d: "M202.906,99.1a1.963,1.963,0,0,1-1.372-.431,1.617,1.617,0,0,1-.47-1.255V93.679H199.75V92.628h1.313V91l1.2-.3v1.928h1.823v1.052h-1.823v3.45a.925.925,0,0,0,.216.693.982.982,0,0,0,.7.209,2.435,2.435,0,0,0,.457-.039c.131-.026.274-.065.431-.111v1.052a2.631,2.631,0,0,1-.562.131A5.044,5.044,0,0,1,202.906,99.1Z",
    transform: "translate(-108.699 -89.877)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14970",
    "data-name": "Path 14970",
    d: "M215.743,98.81A4.336,4.336,0,0,1,214,98.457a4.493,4.493,0,0,1-2.7-4.162,4.624,4.624,0,0,1,.333-1.758,4.422,4.422,0,0,1,.941-1.437,4.535,4.535,0,0,1,1.4-.967,4.261,4.261,0,0,1,1.738-.353,4.625,4.625,0,0,1,1.908.4,4.247,4.247,0,0,1,1.516,1.111l-.876.876a3.113,3.113,0,0,0-1.137-.869,3.41,3.41,0,0,0-1.411-.307,3.034,3.034,0,0,0-1.228.248,3.1,3.1,0,0,0-.987.693,3.2,3.2,0,0,0-.66,1.045,3.557,3.557,0,0,0-.235,1.313,3.6,3.6,0,0,0,.235,1.307,3.167,3.167,0,0,0,.666,1.059,3.04,3.04,0,0,0,1,.7,3.088,3.088,0,0,0,1.235.248,2.887,2.887,0,0,0,1.366-.327,2.8,2.8,0,0,0,1.47-2.176H215.75v-1.15h4.162V94.4a4.723,4.723,0,0,1-.314,1.738,4.241,4.241,0,0,1-.882,1.4,3.927,3.927,0,0,1-1.326.928A3.876,3.876,0,0,1,215.743,98.81Z",
    transform: "translate(-112.702 -89.558)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14971",
    "data-name": "Path 14971",
    d: "M226.838,91.269a.7.7,0,0,1-.523-.229.76.76,0,0,1-.216-.542.739.739,0,0,1,.216-.542.715.715,0,0,1,.523-.216.745.745,0,0,1,.536.216.714.714,0,0,1,.216.542.76.76,0,0,1-.216.542A.711.711,0,0,1,226.838,91.269Zm-.608,7.39V92.295h1.215v6.364Z",
    transform: "translate(-117.832 -89.544)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14972",
    "data-name": "Path 14972",
    d: "M233.262,102.628a5.218,5.218,0,0,1-1.32-.163,4.507,4.507,0,0,1-1.163-.464l.464-.974a5.142,5.142,0,0,0,1.026.418,3.748,3.748,0,0,0,.967.131,1.752,1.752,0,0,0,1.228-.386,1.475,1.475,0,0,0,.418-1.137v-.725a2.845,2.845,0,0,1-1.856.66,2.958,2.958,0,0,1-1.562-.431,3.136,3.136,0,0,1-1.124-1.176,3.34,3.34,0,0,1-.412-1.64,3.273,3.273,0,0,1,.418-1.653,3.153,3.153,0,0,1,1.13-1.176,3.007,3.007,0,0,1,1.594-.431,2.87,2.87,0,0,1,.967.17,2.922,2.922,0,0,1,.856.484V93.6h1.2v6.462a2.481,2.481,0,0,1-.732,1.908A3.075,3.075,0,0,1,233.262,102.628Zm-.085-3.711a2.378,2.378,0,0,0,.974-.2,1.861,1.861,0,0,0,.725-.555V95.316a1.984,1.984,0,0,0-.732-.549,2.35,2.35,0,0,0-.967-.2,2,2,0,0,0-1.052.287,2.032,2.032,0,0,0-.738.784,2.359,2.359,0,0,0,0,2.208,2.182,2.182,0,0,0,.738.784A2,2,0,0,0,233.177,98.916Z",
    transform: "translate(-119.16 -90.84)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14973",
    "data-name": "Path 14973",
    d: "M245.66,98.749V90h1.274v3.75h4.515V90h1.274v8.749h-1.274V94.94h-4.515v3.809Z",
    transform: "translate(-124.612 -89.634)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14974",
    "data-name": "Path 14974",
    d: "M261.281,100.138a2.474,2.474,0,0,1-1.261-.314,2.167,2.167,0,0,1-.849-.882,2.734,2.734,0,0,1-.3-1.307V93.65h1.2v3.777a1.651,1.651,0,0,0,.418,1.189,1.476,1.476,0,0,0,1.124.438,1.807,1.807,0,0,0,.889-.216,1.7,1.7,0,0,0,.634-.621V93.657h1.215v6.364h-1.215v-.647A2.483,2.483,0,0,1,261.281,100.138Z",
    transform: "translate(-129.19 -90.899)",
    fill: "#393086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14975",
    "data-name": "Path 14975",
    d: "M269.43,98.624V89.875l1.215-.235v3.221a2.718,2.718,0,0,1,1.882-.7,2.925,2.925,0,0,1,1.581.438,3.235,3.235,0,0,1,1.124,1.176,3.54,3.54,0,0,1-.007,3.326,3.22,3.22,0,0,1-1.13,1.183,3.056,3.056,0,0,1-2.581.268,3.058,3.058,0,0,1-.882-.484v.549h-1.2Zm2.934-.993a2.016,2.016,0,0,0,1.065-.287,2.048,2.048,0,0,0,.745-.784,2.184,2.184,0,0,0,.281-1.117,2.222,2.222,0,0,0-1.026-1.914,2.016,2.016,0,0,0-1.065-.287,2.321,2.321,0,0,0-.974.2,2.087,2.087,0,0,0-.751.562V96.88a2.08,2.08,0,0,0,.758.549A2.334,2.334,0,0,0,272.364,97.631Z",
    transform: "translate(-132.851 -89.509)",
    fill: "#393086"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWith);
export default __webpack_public_path__ + "static/media/LogoWith.41dfec1f.svg";
export { ForwardRef as ReactComponent };